var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6875 10.5898C19.6875 15.9414 15.3125 20.2773 10 20.2773C4.64844 20.2773 0.3125 15.9414 0.3125 10.5898C0.3125 5.27734 4.64844 0.902344 10 0.902344C15.3125 0.902344 19.6875 5.27734 19.6875 10.5898ZM8.86719 15.7461L16.0547 8.55859C16.2891 8.32422 16.2891 7.89453 16.0547 7.66016L15.1562 6.80078C14.9219 6.52734 14.5312 6.52734 14.2969 6.80078L8.4375 12.6602L5.66406 9.92578C5.42969 9.65234 5.03906 9.65234 4.80469 9.92578L3.90625 10.7852C3.67188 11.0195 3.67188 11.4492 3.90625 11.6836L7.96875 15.7461C8.20312 15.9805 8.63281 15.9805 8.86719 15.7461Z",
    fill: "#C7C644"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIcon);
export default __webpack_public_path__ + "static/media/tick-icon.8a25d37a10265fc23e4c7b7960a29d59.svg";
export { ForwardRef as ReactComponent };